module.exports = __webpack_public_path__ + "img/424.3001a8a6.png";